import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { filter, tap, switchMap, take, distinctUntilChanged } from 'rxjs/operators';
import { OverlayLoaderService } from '@app/shared/services/overlay-loader.service';
import { Municipality, MunicipalityService } from '@app/shared/services/api/municipality.service';
import { UserMunicipalitiesService } from '@app/shared/services/user-municipalities.service';
import { environment } from '@env/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@app/shared/services/auth.service';
import { Subscription } from 'rxjs';
import { MapStoreMunicipality } from '@app/shared/models/municipality/Municipality';

@Component({
  selector: 'app-energiemonitor',
  templateUrl: './_energiemonitor.component.html',
  styleUrls: ['./_energiemonitor.component.scss'],
})
export class EnergieMonitorLegacyComponent implements OnInit, OnDestroy {
  get environment() {
    return environment;
  }
  subs?: Subscription;
  energieMonitorUrl?: SafeResourceUrl;

  constructor(
    public sanitizer: DomSanitizer,
    public httpClient: HttpClient,
    public overlayLoaderService: OverlayLoaderService,
    public municipalityService: MunicipalityService,
    private userMunicipalitiesService: UserMunicipalitiesService,
    private _route: ActivatedRoute,
    private _router: Router,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.subs = this.userMunicipalitiesService.currentMunicipality$
      .pipe(
        tap(() => (this.overlayLoaderService.isLoading = true)),
        filter((municipality: MapStoreMunicipality) => !!municipality?.guid && !!municipality?.key),
        distinctUntilChanged(),
        switchMap((municipality: MapStoreMunicipality) => this.municipalityService.getByMunicipalityGuid(municipality.guid))
      )
      .subscribe((municipality: Municipality[]) => {
        this.authService.applyMunicipalityRestrictions(this.userMunicipalitiesService.currentMunicipality.guid);
        this.authService.permissionLoadComplete$
          .asObservable()
          .pipe(
            filter((a) => a === true),
            take(1)
          )
          .subscribe(() => {
            const energyMonitorUrl = municipality[0].energyMonitorUrl;
            this._route.data.subscribe((data) => {
              data.permissionCodes.forEach((p: any) => {
                const isTeaser = this.authService.permissions[p].teaser === true;
                if (energyMonitorUrl && !isTeaser) {
                  window.open(energyMonitorUrl, '_blank');
                } else if (environment.tenant.trim().toLowerCase() === 'lew') {
                  this.energieMonitorUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`${environment.energieMonitorUrl}/lew-schwaben`);
                } else {
                  this.energieMonitorUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`${environment.energieMonitorUrl}/demo`);
                }
              });
            });
            this.overlayLoaderService.isLoading = false;
          });
      });
  }

  ngOnDestroy() {
    if (this.subs) {
      this.subs.unsubscribe();
    }
  }

  gotoDashboard() {
    this._router.navigateByUrl('/instrumententafel');
  }

  goToLink() {
    window.open(environment.lewenergieMonitorUrl, '_blank');
  }
}
